import PROFILE_LIST from "@/profiles/profileList.js";

const BASE_URL = import.meta.env.VITE_BASE_URL;

const BASE_URL_PORTAL = import.meta.env.VITE_BASE_URL_PORTAL;

const URL_LOGOUT = import.meta.env.VITE_URL_LOGOUT;

const config = {
	profile: PROFILE_LIST.DEV,
	apis: {
		urls: {
			BASE_URL,
			BASE_URL_PORTAL,
			URL_LOGOUT,
			// API_CONSULTA_ENTIDADE: `${BASE_URL_PORTAL}/api-consulta-entidade/consulta-entidade`,
			API_CONSULTA_ENTIDADE: "http://localhost:8107/api-consulta-entidade/consulta-entidade",
			// API_FGTAS: `${BASE_URL}/api-fgtas`,
			API_FGTAS: "http://localhost:8199/api-fgtas",
		},
	},
};

console.warn(import.meta.env.VITE_PROFILE);

export default config;
